/* Filtrous stock badge - v15, 2026-09-18 (Adelaide: "if it's backordered
   it's showing out of stock. if it's out of stock, it's also showing out of
   stock with the exception of the preordering for the buffers and that
   preordering should show on the product cards as well").
   - "Sold Out" is retired too: every unbuyable part reads "Out of stock".
   - Preorder is buffers only (the lists in filtrous-v3.js were cut to the
     buffer families + Buffer CLY/NLY) and only while zero on hand - a buffer
     with stock reads In stock. isPre() below is that rule.
   - Preorder now shows on the recently-viewed cards and in quick view, and
     those cards also carry the Out of stock line.

   v14, 2026-09-16 (Adelaide: "instead of backorder put
   out of stock from now on for everything. and click Join the Waitlist."
   The word Backorder is retired on every surface: the badge, card note,
   quick-view badge and control titles all read "Out of stock" in the same
   red as Sold Out. Every surface that used to grey the Add for a backorder
   now offers the navy "Join the Waitlist" control instead - the PDP renders
   the real email form (filtrous-v3.js, fv3Waitlist()), and cards / quick
   view / FBT / cart upsell / grid + search rows link to it (waitlistRow()).
   The signup still lands in the Google Sheet and now also pings Plankton in
   Slack via pingWaitlist() in filtrous-v3.js. Sold Out (availableForSale
   false) keeps its word and gets the same waitlist control.)
   v13, 2026-09-10 (the v10 /cart/add.js backstop and
   the card/quick-view painters refused vetted PREORDER parts too: Shopify
   reports them backorder (CONTINUE + zero on hand) and nothing here consulted
   the hardcoded lists, so 88 of 98 preorder SKUs could not be added - "Could
   not add EXK-BD-0096. Please retry." filtrous-v3.js now publishes its lists
   as window.FV3_PREORDER and vettedPreorder() reads it; out of stock still
   beats a vetted date). v12 2026-09-03 (back-in-stock send button greyed -
   "blue and grey"). v11 same day (out-of-stock now beats a vetted
   preorder date; blockCart no longer greys the notify button). v10 same day
   (renderer-agnostic /cart/add.js backstop - see addIsBlocked). v9 same day (audit fixes: the FBT/recently-viewed
   "Sold Out" buttons that carry no data-vid, productHref() walking past a
   wrapping <a>, and cards showing a dead control with no stock line).
   v8 same day (every renderer's buy control mirrors the product page - cards,
   quick view, FBT bundle, cart upsell). v7/v6 same day (cards + quick view).
   v5 same day ("backorder should not be addable"). v4 same day (PDP badge on
   the in-app #/p/<sku> route). v3 same day ("it should only be preorder if we
   have a lead time, otherwise it's backorder"). v2 same day ("we should say
   sold out if sold out"). v1 2026-08-27 ("the OSK SKUs are not sold out").

   THE RULE (Adelaide, 2026-09-03) - what may be added to cart:
     preorder WITH a vetted ship date  -> yes
     in stock                          -> yes
     backorder (no confirmed date)     -> NO
     preorder WITHOUT a lead date      -> NO  (no such state renders: every
                                          Preorder label carries a date, and a
                                          dateless one is labelled Backorder)
     out of stock                      -> NO

   The three stock states, told apart by lead time:

     Preorder   orderable AND we have a vetted ship date. Only the hardcoded
                PREORDER / PREORDER_ALT lists in filtrous-v3.js and
                HF_PREORDER / HF_PREORDER_ALT in filtrous-home-families.js
                qualify - someone confirmed those lead times. They render
                "Preorder - ships <date>", stay orderable, and this file leaves
                them alone.
     Backorder  zero on hand, NO confirmed date. Discovered live from Shopify
                (availableForSale && currentlyNotInStock), so nobody has vetted
                a lead time. ~147 of 600 SKUs. NOT orderable - see blockCart().
                Shopify would take the order (these are CONTINUE variants),
                which is exactly why the block is asserted here.
     Sold Out   availableForSale false. Cannot be ordered at all; Shopify
                rejects it server-side too, the variant being DENY.

   The app asserts stock in two places - stockCell() in filtrous-v3.js for the
   sheet + PDP, productRow() in filtrous-home-families.js for search rows - and
   both compute it from p.available alone. The merch renderers do not compute it
   at all. What that got wrong, and what this file fixes:

   1. QUOTE items (OSK-*, EXK-BD-0096-PP) are never stocked to order. Price and
      buy button already switch to "Call for Quote" via isOskQuote(), but the
      stock cell fell through to the on-hand logic and read "Sold Out". They
      must not assert stock at all: the badge reads the sales number,
      (858) 224-9100, so the row is not two "Call for Quote"s side by side.
   2. BACKORDER items read "Backorder" - no date, because none is confirmed.
      The amber "pre" class is reused for styling: it is the intermediate
      colour, and reusing it avoids adding CSS and widening the class regex in
      setState(). The /\bpre\b/ early return in apply() still protects the
      hardcoded "Preorder - ships <date>" rows, which arrive already carrying
      that class from their own renderer.
   3. "BACKORDER" IN SEARCH ROWS. productRow() renders its own badge instead of
      calling stockCell(), and its third state is hardcoded:
        hfIsPre(p) ? "Preorder - ships <date>" : p.available ? "In stock"
                                                             : "Backorder"
      So an unavailable part read "Sold Out" on the grid and PDP but "Backorder"
      in search - the most misleading word available, since it promises
      orderable-ships-later when availableForSale is false. Surfaced by
      MBP-21-4425 (Alliance 70% Nitric Acid), whose remaining units were
      committed to a customer, so its policy went CONTINUE -> DENY. In
      productRow() "Backorder" is emitted if and only if p.available is false,
      so the rewrite is unconditional - and it runs LAST, after the BACKORDER
      branch has already claimed the genuinely-orderable rows.
   4. THE PDP BADGE ON THE IN-APP ROUTE. See currentPdpSku().
   5. BACKORDER WAS STILL ADDABLE TO CART. See blockCart().
   6. MERCH CARDS AND THE QUICK-VIEW MODAL IGNORED STOCK ENTIRELY. See
      paintCards() / paintQuickView(). Two traps there, both because the modal
      is mounted on document.body OUTSIDE #fv3-app: the app-scoped
      MutationObserver never saw it open (hence the second observer in boot()),
      and #fv3-app-prefixed CSS never reached it (hence the unscoped rules).

   Runs as a post-pass over what the other renderers produce, rather than inside
   any one of them, so every surface is corrected from a single file.

   COVERAGE (v9): every Add control on the storefront is now gated on stock -
   .fv3-add (grid, search rows, PDP), .pc-add (merch rails), .fqv-add (quick
   view), .fbt-cardadd + the bundle tick-boxes (Frequently bought together /
   Complete the protocol), and .fcu-add (cart drawer upsell). Each keys off
   whatever identifier its renderer exposes: SKU text, data-vid, or the handle
   in the row's product link - hence BY_VID and BY_HANDLE. Where a renderer has
   already worked stock out for itself, its own output is the signal: an
   .fbt-cardadd with NO data-vid and the text "Sold Out" is filtrous-fbt.js
   saying the part is unavailable, and gets the notify treatment on that basis.

   v10 adds a backstop at /cart/add.js so a renderer that is missed, or added
   later, cannot actually sell an unbuyable part. The per-renderer gating stays:
   the backstop is the last line, not the first - a customer should see that a
   part is unavailable, not click and be refused. It fails open by design; see
   addIsBlocked().

   BACK-IN-STOCK CAPTURE (verified 2026-09-03, not changed here beyond colour):
   the navy .fv3-notify-btn reveals .fv3-notify[data-sku]; wireNotify() in
   filtrous-v3.js validates the address, then notifyBackInStock() POSTs
   {email, sku, product} no-cors to BACK_IN_STOCK_URL - the Filtrous Apps
   Script, i.e. the Google Sheet, the same endpoint the newsletter signup uses.
   It only falls back to Shopify's /contact form if that constant is ever
   emptied, and CFG.mock would make it a no-op; neither applies on 1.13.

   Additive asset; remove its loader line in sections/filtrous-v3-app.liquid to
   revert. */
(function () {
  'use strict';

  /* The stock line of a quote part carries the sales number instead of a
     stock word (2026-09-17, Adelaide). The price cell still reads "Call for
     Quote", so the row says what it costs and who to ask, once each. */
  var QUOTE_PHONE = '(858) 224-9100';

  /* mirrors isOskQuote() in filtrous-v3.js - keep the two in sync */
  function isQuote(sku) {
    var s = String(sku || '').toUpperCase();
    return s.indexOf('OSK') >= 0 || /^(EXK|MDA|MDB|MNA|MNB|MXA)-/.test(s);
  }

  /* BACKORDER/UNAVAIL are keyed by SKU, but the FBT tick-boxes and card adds
     identify a part only by variant id, and the cart-drawer upsell only by the
     handle in its title link - so the index tap builds both lookups too. */
  var BACKORDER = {}, UNAVAIL = {}, BY_VID = {}, BY_HANDLE = {};

  /* The vetted lists live in filtrous-v3.js (PREORDER + PREORDER_ALT), which
     publishes their union as window.FV3_PREORDER. A part on that list is
     "Preorder - ships <date>" and stays orderable even though Shopify reports
     it as backorder; only UNAVAIL beats it. Read at call time, not at load -
     this file is queued before filtrous-v3.js. If the export is missing the
     part is treated as plain backorder, exactly as before v13. */
  function vettedPreorder(sku) {
    var m = window.FV3_PREORDER;
    return !!(m && sku && m[String(sku).toUpperCase()]);
  }

  /* v15: a buffer on the list that is zero on hand and still sellable. A
     buffer with stock is just In stock. */
  function isPre(sku) {
    return !!(sku && vettedPreorder(sku) && BACKORDER[sku] && !UNAVAIL[sku]);
  }
  function preText(sku) {
    var d = null;
    try { d = window.FV3_PRE_SHIP ? window.FV3_PRE_SHIP(sku) : null; } catch (e) {}
    return d ? 'Preorder \u2014 ships ' + d : 'Preorder';
  }
  var PRE_COLOR = '#b26a00', OUT_COLOR = '#A2492F';
  var INDEX_READY = false;

  if (!document.getElementById('fsb-css')) {
    var st = document.createElement('style');
    st.id = 'fsb-css';
    st.textContent =
      '.fv3-stock.quote,.pdp-stock.quote{color:var(--navy,#082F4B)}' +
      '.fv3-stock.quote .dotm{display:none}' +
      /* Backordered parts keep their controls in place but greyed, rather than
         vanishing the way an unavailable row does in filtrous-v3.js. The theme
         styles .fcu-add:disabled / .pc-add:disabled but not .fv3-add.

         NOT scoped under #fv3-app. The quick-view modal is mounted on
         document.body, outside the app root, so an #fv3-app-prefixed rule does
         not reach it - the notify button rendered as a bare underlined link
         until this was unscoped. Every class here is Filtrous-specific, so
         there is nothing else on the page for them to hit. */
      '.fv3-add:disabled,.fv3-add[disabled],.pc-add:disabled,.fqv-add:disabled' +
      '{background:#e3e9ee;color:#8496a3;cursor:default}' +
      '.fv3-qty:disabled,.fv3-step:disabled{background:#f2f5f7;color:#8496a3;cursor:default}' +
      /* matches the PDP notify button exactly - #082F4B navy, white, 700, 8px
         radius - so an unavailable card reads the same as its product page.
         Values lifted from the computed style of .fv3-notify-btn. */
      '.fsb-notify{display:block;width:100%;box-sizing:border-box;background:#082F4B;color:#fff;' +
      'font-weight:700;font-size:13.5px;font-family:inherit;line-height:1.3;border:0;border-radius:8px;' +
      'padding:9px 14px;text-align:center;text-decoration:none;cursor:pointer}' +
      '.fsb-notify:hover{background:#0d3f63;color:#fff}' +
      /* v14: the grid and search rows are <a> inside #fv3-app td, where the
         theme's own link colour (an id-scoped rule) outranked the single class
         above and painted "Join the Waitlist" navy on navy - verified invisible
         on the weighing-v2 grid 2026-09-16. Id-scoped + !important so nothing
         in the table wins; the quick-view modal is outside #fv3-app and keeps
         the unscoped rule. */
      '#fv3-app .fsb-notify,#fv3-app .fsb-notify:link,#fv3-app .fsb-notify:visited,#fv3-app .fsb-notify:hover,' +
      '#fv3-app .fsb-notify:focus{color:#fff !important;text-decoration:none}' +
      /* the FBT card add and the cart-drawer upsell add are flex children in a
         row beside a stepper, so a full-width block there would break the
         layout - this variant sits in the row the way the button it replaces
         did (12.5px / 7px radius, matching .fbt-cardadd and .fcu-add). */
      '.fsb-notify.fsb-inline{display:inline-flex;align-items:center;justify-content:center;' +
      'width:auto;flex:1 1 auto;font-size:12.5px;padding:8px 12px;border-radius:7px}' +
      '.fsb-notify.fsb-nowrap{flex:0 0 auto;white-space:nowrap;font-size:12px;padding:8px 11px}' +
      /* mirrors .pc-pre, the note the card renderer already uses for
         "Preorder - ships <date>", so the state reads the same way */
      '.fsb-note{font-size:11.5px;font-weight:600;margin:2px 0 4px}' +
      /* The waitlist send control is a quiet outlined ICON button (2026-09-17,
         Adelaide: "i don't like such a clunky join button; can you just do a
         gentle send icon"). Its look now lives entirely in
         assets/filtrous-v3.css - the grey #5F7181 slab that used to be forced
         here, so the control would not read as a buy action, is gone: an
         unfilled icon does not read as one either. */
      '';
    document.head && document.head.appendChild(st);
  }

  /* Read-only tap on the catalog index (same pattern as
     filtrous-recently-viewed.js). Loads AFTER filtrous-live-stock.js so the
     p.backorder flag it sets is already on the payload. */
  /* ---- renderer-agnostic cart backstop -------------------------------------
     Every Add control is gated individually above, but each one had to be
     FOUND first, and twice in one session a renderer turned out to build its
     own button that grepping the minified source had not revealed
     (filtrous-fbt.js's no-data-vid "Sold Out" button; the recently-viewed rail
     reusing .fbt-cardadd). This catches whatever is still missed, and anything
     added later, at the one point every renderer must pass through.

     It is deliberately the LAST line of defence, not the first: the buttons are
     still gated, because a customer should see that a part is unavailable
     rather than click and be refused.

     FAILS OPEN, always. It blocks only when the body parses cleanly AND a
     variant id in it is positively known unbuyable. An unparseable body, an
     unknown id, a Request object (whose body is a stream that reading would
     consume), or an XHR caller all fall straight through. A missed block is a
     wrong badge; a wrongly blocked add is a lost order, so the asymmetry runs
     that way on purpose.

     The FBT "Add all" posts several items at once. If any one is blocked the
     whole batch is refused rather than silently part-ordered - the tick-boxes
     already exclude unbuyable items, so reaching here means something else is
     wrong and the honest move is to refuse the whole thing. */
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  function blockedVid(id) {
    var sku = BY_VID[String(id)];
    return sku ? !!(UNAVAIL[sku] || (BACKORDER[sku] && !vettedPreorder(sku))) : false;
  }

  function addIsBlocked(init) {
    try {
      var body = init && init.body, ids = [], j, m, v, i;
      if (!body) return false;
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          j = JSON.parse(body);
          if (j.id != null) ids.push(j.id);
          if (j.items && j.items.length) {
            for (i = 0; i < j.items.length; i++) if (j.items[i] && j.items[i].id != null) ids.push(j.items[i].id);
          }
        } else {
          m = body.match(/(?:^|&)id=([^&]+)/);        /* urlencoded id=123&quantity=1 */
          if (m) ids.push(decodeURIComponent(m[1]));
        }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData && body.get) {
        v = body.get('id');
        if (v != null) ids.push(v);
      } else return false;
      for (i = 0; i < ids.length; i++) if (blockedVid(ids[i])) return true;
      return false;
    } catch (e) { return false; }
  }

  /* shaped like Shopify's own refusal so existing catch/.description handling
     in the renderers reports it rather than throwing */
  function cartRefusal() {
    return new Response(JSON.stringify({
      status: 422, message: 'Cart Error',
      description: 'This item is not available to order right now.'
    }), {
      status: 422, statusText: 'Unprocessable Entity',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  var orig = window.fetch;
  if (orig) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      /* checked BEFORE orig runs - after it, the item is already in the cart */
      if (CART_ADD.test(String(url)) && typeof input === 'string' && addIsBlocked(arguments[1])) {
        window.console && console.info && console.info('[fsb] blocked an unbuyable add: ' + String(url));
        return Promise.resolve(cartRefusal());
      }
      var p = orig.apply(this, arguments);
      if (String(url).indexOf('catalog-index') === -1) return p;
      return p.then(function (res) {
        if (res && res.ok) {
          res.clone().json().then(function (d) {
            ((d && d.products) || []).forEach(function (x) {
              if (!x || !x.sku) return;
              var k = String(x.sku).toUpperCase();
              if (x.backorder) BACKORDER[k] = 1;
              /* the card pass needs to tell "cannot be ordered" from
                 "orderable but empty", and only the index carries that -
                 nothing in a rail card's markup says so. */
              if (x.available === false) UNAVAIL[k] = 1;
              if (x.vid) BY_VID[String(x.vid)] = k;
              if (x.handle) BY_HANDLE[String(x.handle)] = k;
            });
            INDEX_READY = true;
            paint();
          }).catch(function () {});
        }
        return res;
      });
    };
  }

  function setState(el, cls, text) {
    el.className = el.className.replace(/\b(in|out|pre|quote)\b/g, '').replace(/\s+/g, ' ').trim() + ' ' + cls;
    var dot = el.querySelector('.dotm');
    el.textContent = text;
    if (dot) el.insertBefore(dot, el.firstChild);
    el.setAttribute('data-fsb', '1');
  }

  /* v5 (Adelaide: "backorder should not be addable") - a backordered part must
     not be orderable. Nothing upstream stops it: filtrous-v3.js and
     productRow() only strip or disable the buy controls when p.available is
     false, and a backorder carries p.available === true by construction - that
     is the whole point of the 2026-08-27 split. Shopify will not stop it
     either, because these variants are CONTINUE: /cart/add.js returns 200 and
     the order is taken (verified 2026-09-03). So the block has to be asserted
     here.

     Disabled rather than removed. filtrous-v3.js renders an EMPTY cell for an
     unavailable row, but emptying the cell from a post-pass would fight the
     app's own re-render and shift the layout; greying keeps the control where
     the eye expects it and reads as "not right now" rather than "never". The
     search renderer already disables rather than removes, so this matches it.

     Both the grid and the PDP name their button .fv3-add, and the search row's
     button carries the same class alongside data-hfadd, so one selector covers
     all three. On the PDP the buy row is a SIBLING of the badge, not an
     ancestor, hence the parentElement branch. */
  function disable(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].disabled = true;
      nodes[i].setAttribute('aria-disabled', 'true');
      nodes[i].setAttribute('title', 'Out of stock - join the waitlist');
    }
  }

  function blockCart(el) {
    var scope = (el.closest && el.closest('tr')) || null;
    if (!scope && el.parentElement && el.parentElement.querySelector('.fv3-buyrow')) scope = el.parentElement;
    if (!scope) return;
    /* :not(.fv3-notify-btn) matters - the PDP's "Email me when it's back"
       button carries the .fv3-add class too, and greying that out would take
       away the one action left on an unavailable part. */
    disable(scope.querySelectorAll('.fv3-add:not(.fv3-notify-btn), input.fv3-qty, button.fv3-step, .fv3-buyrow .dec, .fv3-buyrow .inc'));
  }

  /* v14 - grid and search rows. The sheet renders an EMPTY buy cell for an
     unavailable row and a greyed qty + Add for a backordered one; neither
     offers the customer anything to do. Both now carry the same navy "Join
     the Waitlist" control the cards use, linking to the product page where
     the real form lives. The row is keyed off the badge cell (el), the link
     off the row's own title link, falling back to the in-app #/p/<sku> route.
     Idempotent: a cell already holding .fsb-notify is left alone, and a
     re-rendered row arrives unstamped and is simply re-treated. */
  function waitlistRow(el, sku) {
    var row = el.closest && el.closest('tr');
    if (!row) return;
    var cell = row.querySelector('.fv3-qadd');
    if (!cell) {
      var tds = row.querySelectorAll('td'), last = tds[tds.length - 1];
      if (last && last !== el.parentElement && !last.firstChild) cell = last;
    }
    if (!cell || cell.querySelector('.fsb-notify')) return;
    var lk = row.querySelector('.fv3-pname a[href], a[href*="/products/"], a[href*="#/p/"]');
    var a = notifyEl(lk ? lk.getAttribute('href') : '#/p/' + encodeURIComponent(sku));
    a.className = a.className + ' fsb-inline fsb-nowrap';
    while (cell.firstChild) cell.removeChild(cell.firstChild);
    cell.appendChild(a);
  }

  /* v6 (Adelaide: "the product cards should match the add to cart options if
     offered. If something is out of stock then the product card should be a
     blue with email me when it's back just like the product page reflects it")

     The merch renderers - filtrous-pdp-merch.js (Complete The Protocol,
     Recommended For You, Products related, Recently viewed),
     filtrous-quick-view.js - build their own product cards with their own Add
     buttons (.pc-add / .fqv-add) and never consult availability, so an
     unavailable part offered an Add button that Shopify would then refuse, and
     a backordered one offered an Add that would silently succeed. Both now
     mirror what the product page shows for the same part:

       unavailable  ->  navy "Email me when it's back", linking to the PDP,
                        where the real notify form lives. Reproducing that form
                        inside a rail card would mean duplicating its wiring;
                        sending the customer one click to the working one is
                        both simpler and where they can read the full detail.
       backorder    ->  Add greyed out, same as the PDP buy row.
       otherwise    ->  left exactly as the merch renderer built it.

     Cards are stamped data-fsbc so the pass is idempotent - filtrous-pdp-merch.js
     re-inserts its rail on every observer pass, and an unstamped rewrite would
     ping-pong with it (see the section-order note in that file's header). A
     rebuilt card arrives unstamped and is simply re-treated. */
  function notifyEl(href, label) {
    var a = document.createElement('a');
    a.className = 'fsb-notify';
    a.setAttribute('href', href || '#');
    a.textContent = label || 'Join the Waitlist';
    return a;
  }

  /* null means "leave whatever the renderer produced alone". Quote parts are
     null on purpose - every renderer already branches on isOskQuote() and
     shows "Call for Quote"; second-guessing that here would fight it. */
  function stateOf(sku) {
    if (!sku || isQuote(sku)) return null;
    if (UNAVAIL[sku]) return 'unavail';
    if (BACKORDER[sku] && !vettedPreorder(sku)) return 'backorder';
    return null;
  }

  /* nearest product link at or above el - the FBT card, the upsell row and the
     rail card all wrap their button near an <a href="/products/...">, but at
     different depths, so walk rather than assume one. */
  function productHref(el) {
    /* closest() FIRST. The recently-viewed card is itself an
       <a class="fv3-rv-card" href="/products/..."> wrapping the button, and
       walking up querySelector-ing would skip past it (an ancestor <a> is not
       its own descendant) and return the FIRST link of the whole rail - i.e.
       some other product's URL. */
    var a = el.closest && el.closest('a[href*="/products/"]');
    if (a) return a.getAttribute('href');
    var p = el, n = 0, lk;
    while (p && n < 6) {
      lk = p.querySelector && p.querySelector('a[href*="/products/"]');
      if (lk) return lk.getAttribute('href');
      p = p.parentElement; n++;
    }
    return null;
  }

  function handleSku(href) {
    var m = href && href.match(/\/products\/([^/?#]+)/);
    return m ? BY_HANDLE[m[1]] : null;
  }

  /* The card renderer prints title / sku / price and, for the hardcoded
     preorder list, a .pc-pre note - but nothing at all for backorder or sold
     out. A greyed Add with no reason next to it does not "match the product
     page", which states the stock line above the buy control, so add the same
     line here. Placed after .pc-p to sit where .pc-pre sits. */
  function cardNote(card, text, color) {
    if (card.querySelector('.fsb-note') || card.querySelector('.pc-pre')) return;
    var body = card.querySelector('.pc-body'), price = card.querySelector('.pc-p');
    if (!body) return;
    var d = document.createElement('div');
    d.className = 'fsb-note';
    d.style.color = color;
    d.textContent = text;
    if (price && price.parentNode === body) body.insertBefore(d, price.nextSibling);
    else body.appendChild(d);
  }

  function paintCards() {
    var cards = document.querySelectorAll('#fv3-app .fv3-pcard');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.getAttribute('data-fsbc')) continue;
      var b = c.querySelector('.pc-sku b'), add = c.querySelector('.pc-add');
      if (!b || !add) continue;
      var sku = b.textContent.trim().toUpperCase();
      /* quote parts are already handled by the merch renderer's own
         isOskQuote() branch - do not second-guess it */
      if (isQuote(sku)) { c.setAttribute('data-fsbc', '1'); continue; }
      if (UNAVAIL[sku]) {
        var lk = c.querySelector('a.pc-link');
        cardNote(c, 'Out of stock', OUT_COLOR);
        add.parentNode.replaceChild(notifyEl(lk && lk.getAttribute('href')), add);
        c.setAttribute('data-fsbc', '1');
      } else if (BACKORDER[sku] && !vettedPreorder(sku)) {
        var lk2 = c.querySelector('a.pc-link');
        cardNote(c, 'Out of stock', OUT_COLOR);
        add.parentNode.replaceChild(notifyEl(lk2 && lk2.getAttribute('href')), add);
        c.setAttribute('data-fsbc', '1');
      } else if (isPre(sku)) {
        /* the card renderer prints .pc-pre itself; cardNote skips if it did */
        cardNote(c, preText(sku), PRE_COLOR);
        c.setAttribute('data-fsbc', '1');
      }
    }
  }

  /* The modal carries its own badge, span.fqv-stock, which the quick-view
     renderer fills from p.available alone - so it read "In stock" for a part
     the same modal was refusing to sell. Colours match what the PDP computes:
     #A2492F for out, #b26a00 for the amber intermediate. */
  function fqvBadge(body, text, color) {
    var b = body.querySelector('.fqv-stock');
    /* v15: quick view only prints the badge for available parts, so a
       not-sellable part had no stock line at all - add one after the price */
    if (!b) {
      var pr = body.querySelector('.fqv-p');
      if (!pr) return;
      b = document.createElement('span');
      b.className = 'fqv-stock';
      b.appendChild(document.createElement('i'));
      pr.parentNode.insertBefore(b, pr.nextSibling);
    }
    var dot = b.querySelector('.dotm') || b.querySelector('i');
    b.textContent = text;
    if (dot) b.insertBefore(dot, b.firstChild);
    b.style.color = color;
  }

  /* filtrous-fbt.js: per-card "Add to cart" buttons keyed by data-vid, plus the
     bundle tick-boxes feeding "Add all N to Cart". Neither consults stock.
     Unbuyable tick-boxes are unchecked AND locked, then one change event is
     dispatched so the FBT's own sync() recomputes the button's count and
     disables it at zero - cheaper and safer than reimplementing that sum. */
  function paintFbt() {
    var i, n, st, a;
    /* NOT [data-vid]. filtrous-fbt.js already knows about unavailable parts:
       it omits data-vid and renders a disabled button reading "Sold Out"
       (2 of 20 on a typical PDP). Selecting only [data-vid] skipped exactly
       the parts that most need the notify treatment, leaving a dead grey
       "Sold Out" button where the product page offers to email the customer.
       With no vid to look up, the renderer's own label is the signal.
       These buttons also power the Recently viewed rail (.fv3-rv), which
       reuses .fbt-cardadd rather than .fv3-pcard. */
    var btns = document.querySelectorAll('.fbt-cardadd');
    for (i = 0; i < btns.length; i++) {
      n = btns[i];
      if (n.getAttribute('data-fsbc')) continue;
      var vid = n.getAttribute('data-vid');
      st = vid ? stateOf(BY_VID[vid])
               : (/sold\s*out|out of stock/i.test(n.textContent) ? 'unavail' : null);
      n.setAttribute('data-fsbc', '1');
      if (st === 'unavail' || st === 'backorder') {
        a = notifyEl(productHref(n));
        a.className = a.className + ' fsb-inline';
        n.parentNode.replaceChild(a, n);
      }
    }
    var cbs = document.querySelectorAll('.fv3-fbt input[type="checkbox"][data-vid]'), changed = null;
    for (i = 0; i < cbs.length; i++) {
      n = cbs[i];
      if (n.getAttribute('data-fsbc')) continue;
      st = stateOf(BY_VID[n.getAttribute('data-vid')]);
      n.setAttribute('data-fsbc', '1');
      if (!st) continue;
      if (n.checked) { n.checked = false; changed = n; }
      n.disabled = true;
      n.setAttribute('title', 'Out of stock - join the waitlist on the product page');
    }
    if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* filtrous-cart-upsell.js: .fcu-add in the cart drawer. Its rows carry no
     sku or vid attribute, only the title link, so the handle is the key. */
  function paintCartUpsell() {
    var adds = document.querySelectorAll('.fcu-add');
    for (var i = 0; i < adds.length; i++) {
      var n = adds[i];
      if (n.getAttribute('data-fsbc')) continue;
      var href = productHref(n), st = stateOf(handleSku(href));
      n.setAttribute('data-fsbc', '1');
      if (st === 'unavail' || st === 'backorder') {
        /* .fcu-row is a compact image + text + button strip; fsb-nowrap keeps
           the label on one line instead of collapsing into the thumbnail. */
        var a = notifyEl(href);
        a.className = a.className + ' fsb-inline fsb-nowrap';
        n.parentNode.replaceChild(a, n);
      }
    }
  }

  function paintQuickView() {
    var body = document.querySelector('.fqv-body');
    if (!body || body.getAttribute('data-fsbc')) return;
    var skuEl = body.querySelector('.fqv-sku'), add = body.querySelector('.fqv-add');
    if (!skuEl || !add) return;
    var m = skuEl.textContent.match(/SKU:\s*([A-Za-z0-9][A-Za-z0-9-]*)/);
    if (!m) return;
    var sku = m[1].toUpperCase();
    if (isQuote(sku)) { body.setAttribute('data-fsbc', '1'); return; }
    if (UNAVAIL[sku]) {
      var lk = body.querySelector('a[href^="/products/"]');
      add.parentNode.replaceChild(notifyEl(lk && lk.getAttribute('href')), add);
      disable(body.querySelectorAll('.fqv-step button'));
      fqvBadge(body, 'Out of stock', OUT_COLOR);
      body.setAttribute('data-fsbc', '1');
    } else if (BACKORDER[sku] && !vettedPreorder(sku)) {
      var lk2 = body.querySelector('a[href^="/products/"]');
      add.parentNode.replaceChild(notifyEl(lk2 && lk2.getAttribute('href')), add);
      disable(body.querySelectorAll('.fqv-step button'));
      fqvBadge(body, 'Out of stock', OUT_COLOR);
      body.setAttribute('data-fsbc', '1');
    } else if (isPre(sku)) {
      fqvBadge(body, preText(sku), PRE_COLOR);
      body.setAttribute('data-fsbc', '1');
    }
  }

  function apply(el, sku) {
    if (!el || !sku || el.getAttribute('data-fsb')) return;
    if (isQuote(sku)) { setState(el, 'quote', QUOTE_PHONE); return; }
    /* OUT OF STOCK BEATS A VETTED DATE, and is therefore tested before the
       preorder guard below. A SKU can sit on the hardcoded PREORDER list AND
       be availableForSale:false: none are today (checked across all 589 index
       rows on 2026-09-03), but those lists are hand-maintained while the live
       flag is not, so the day one of the 89 preorder parts is discontinued its
       ship date would otherwise keep a dead part looking orderable. The v10
       cart backstop would still refuse the order - this keeps the badge from
       lying about it in the first place. */
    if (UNAVAIL[sku]) { setState(el, 'out', 'Out of stock'); blockCart(el); waitlistRow(el, sku); return; }
    /* otherwise leave the hardcoded "Preorder - ships <date>" rows alone -
       those have a vetted lead time and stay orderable */
    if (/\bpre\b/.test(el.className)) return;
    if (BACKORDER[sku] && !vettedPreorder(sku)) { setState(el, 'out', 'Out of stock'); blockCart(el); waitlistRow(el, sku); return; }
    if (el.textContent.trim().toLowerCase() === 'backorder') setState(el, 'out', 'Out of stock');
  }

  /* Which part the PDP badge belongs to. FV3_CONFIG.pdpSku is only stamped on
     the Liquid product page (/products/<handle>); on the in-app route
     #/p/<sku> it is absent, so before v4 paint() skipped the PDP badge there
     entirely and a backordered part kept whatever stockCell() had rendered
     ("In stock"). The route is read FIRST because when both are present it is
     the more current of the two - the app can navigate from one part to
     another without a page load, leaving FV3_CONFIG on the part that was
     server-rendered.

     No stale-badge guard is needed alongside this: the app builds a FRESH
     .pdp-stock element on every in-app navigation (verified 2026-09-03 - a
     probe attribute set on the old node does not survive a #/p/ change), so
     the data-fsb stamp never carries from one part to the next, and blockCart()
     re-runs against the newly rendered buy row. */
  function currentPdpSku() {
    var m = (location.hash || '').match(/^#\/p\/([^/?#]+)/);
    if (m) { try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; } }
    var cfg = (window.FV3_CONFIG && window.FV3_CONFIG.pdpSku) || null;
    if (cfg) return cfg;
    /* v14: the Liquid product page (/products/<handle>) carries no pdpSku in
       FV3_CONFIG at all (checked 2026-09-16 on 1.15), so a backordered part's
       badge there was never repainted and read "In stock" above a greyed Add.
       filtrous-v3.js now renders the right word itself; this fallback keeps
       the post-pass (blockCart, stamps) on the same part. */
    var part = document.querySelector('#fv3-app .pdp-stock') && document.querySelector('#fv3-app .part');
    return part ? part.textContent.trim() : null;
  }

  function paint() {
    var cells = document.querySelectorAll('#fv3-app .fv3-stock');
    for (var i = 0; i < cells.length; i++) {
      var row = cells[i].closest ? cells[i].closest('tr') : null;
      var part = row && row.querySelector('.fv3-part');
      if (part) apply(cells[i], part.textContent.trim().toUpperCase());
    }
    var pdp = document.querySelector('#fv3-app .pdp-stock');
    var sku = currentPdpSku();
    if (pdp && sku) apply(pdp, String(sku).toUpperCase());
    paintCards();
    paintRvCards();
    paintFbt();
    paintDetached();
  }

  /* v15: the recently-viewed / FBT-rail cards (.fv3-rv-card, wrapped in
     .fv3-cardcell by filtrous-fbt.js) print title, sku and price only, so a
     buffer on preorder looked like any in-stock part and an out-of-stock part
     showed a waitlist button with no reason. Same line the rail cards carry,
     placed under the price. Waits for the index so it never stamps a card
     before it knows the state. */
  function paintRvCards() {
    if (!INDEX_READY) return;
    var cards = document.querySelectorAll('.fv3-rv-card');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.getAttribute('data-fsbn')) continue;
      c.setAttribute('data-fsbn', '1');
      var skuEl = c.querySelector('.fv3-rv-sku');
      var sku = skuEl ? skuEl.textContent.trim().toUpperCase() : '';
      if (!sku || isQuote(sku)) continue;
      var text = null, color = null;
      if (UNAVAIL[sku] || (BACKORDER[sku] && !vettedPreorder(sku))) { text = 'Out of stock'; color = OUT_COLOR; }
      else if (isPre(sku)) { text = preText(sku); color = PRE_COLOR; }
      if (!text) continue;
      var d = document.createElement('div');
      d.className = 'fsb-note';
      d.style.color = color;
      d.textContent = text;
      var price = c.querySelector('.fv3-rv-p');
      if (price && price.parentNode === c) c.insertBefore(d, price.nextSibling);
      else c.appendChild(d);
    }
  }

  /* the quick-view modal and the cart drawer both mount on document.body,
     outside #fv3-app, so these two are driven by their own observer as well */
  function paintDetached() {
    paintQuickView();
    paintCartUpsell();
  }

  function boot() {
    paint();
    new MutationObserver(paint).observe(document.getElementById('fv3-app') || document.body, { childList: true, subtree: true });
    /* The quick-view modal is appended to document.body, OUTSIDE #fv3-app, so
       the observer above never sees it open - its parent chain is
       body > div.on > div > .fqv-grid > .fqv-body (verified 2026-09-03).
       Without this second observer paintQuickView() ran only when something
       else happened to mutate #fv3-app, which in practice meant never, and the
       modal kept a live Add button for an unavailable part. Scoped to
       paintQuickView alone rather than the full paint, and it bails on one
       querySelector when no modal is open or it is already stamped. */
    new MutationObserver(paintDetached).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
